import { render, staticRenderFns } from "./tablo.vue?vue&type=template&id=dc5ff6ac&"
import script from "./tablo.vue?vue&type=script&lang=js&"
export * from "./tablo.vue?vue&type=script&lang=js&"
import style0 from "./tablo.vue?vue&type=style&index=0&id=dc5ff6ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionTablo: require('/opt/airport.kg/src/components/section/tablo.vue').default})
